function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M28.812 23.044a.5.5 0 0 1 .21.65 9.498 9.498 0 0 1-17.99-3.423 9.5 9.5 0 0 1 17.2-6.287l.47-2.64a.508.508 0 1 1 1 .18l-.84 4.07v.08l-.05.09v.06l-.09.07h-.29l-3.94-.7a.507.507 0 0 1 .17-1l2.85.51a8.508 8.508 0 0 0-15.496 5.448 8.51 8.51 0 0 0 16.126 3.122.5.5 0 0 1 .67-.23zm-8.449-8.58a.5.5 0 0 1 .48.5v4.7l3.38 2a.5.5 0 0 1-.25.93.49.49 0 0 1-.25-.07l-3.73-2.17-.08-.07-.05-.08v-.08a.49.49 0 0 1 0-.1.47.47 0 0 1 0-.06v-5a.5.5 0 0 1 .5-.5z"
});

var SvgAudit = function SvgAudit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAudit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Audit.810df710.svg";
export { ForwardRef as ReactComponent };